import {
	PRODUCT_TYPE_ALL,
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA,
	getDeviceProductType
} from '../../dashboard/product-filter';

export const filterUsersByProduct = (users, productType) => {
	const selectedProductType = parseInt(productType);
	const userList = users || [];

	if (selectedProductType === PRODUCT_TYPE_ALL) {
		return userList;
	}

	if (selectedProductType !== PRODUCT_TYPE_EVO && selectedProductType !== PRODUCT_TYPE_NOVA) {
		return userList;
	}

	return userList.filter(user =>
		(user.userDevices || []).some(device => getDeviceProductType(device) === selectedProductType)
	);
};
